import { render } from "./OnlineShop.vue?vue&type=template&id=7b3a9bd5"
import script from "./OnlineShop.vue?vue&type=script&lang=js"
export * from "./OnlineShop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__